import type { AnimeItem } from "@/mocks/anime";

type AnimeCardProps = {
  item: AnimeItem;
  rank?: number;
};

export default function AnimeCard({ item, rank }: AnimeCardProps) {
  const isTop = typeof rank === "number" && rank <= 3;
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <div className="relative w-full aspect-[5/7] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`《${item.title}》动漫封面`}
          title={`${item.title} | 51动漫在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-950/75 to-transparent" />

        {typeof rank === "number" && (
          <span
            className={`absolute left-2 top-2 flex h-8 w-8 items-center justify-center rounded-md font-heading text-lg ${
              isTop
                ? "bg-accent-500 text-accent-950"
                : "bg-background-50/90 text-foreground-800"
            }`}
          >
            {rank}
          </span>
        )}

        <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-full bg-background-50/92 px-2 py-0.5 text-xs font-bold text-primary-600">
          <i className="ri-star-fill text-[10px]" />
          {item.score.toFixed(1)}
        </span>

        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {item.badge}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50">
          {item.status}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="font-heading text-xl leading-tight text-foreground-950">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {item.subtitle} · {item.year} · 全 {item.episodes} 集
        </p>
        <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-3">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {item.genre}
          </span>
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}